import api from 'api'

const FETCH_REQUEST = 'realhub/currentUser/FETCH_REQUEST'
const FETCH_SUCCESS = 'realhub/currentUser/FETCH_SUCCESS'
const FETCH_FAILURE = 'realhub/currentUser/FETCH_FAILURE'

// Initial State
const initialState = {
  result: {},
  loaded: false,
  loading: false,
  errors: [],
}

// Actions
export function fetchRequest(){
  return {
    type: FETCH_REQUEST,
  }
}

export function fetchSuccess(payload = {}){
  return {
    type: FETCH_SUCCESS,
    payload,
  }
}

export function fetchFailure(errors = []){
  return {
    type: FETCH_FAILURE,
    errors,
  }
}

// Action Creators
export function hydrateCurrentUser(user){
  return (dispatch) => {
    dispatch(fetchRequest())

    if (user.id){
      dispatch(fetchSuccess(user))
    } else {
      dispatch(fetchFailure(['Could not hydrate undefined user.']))
    }
  }
}

export function loadCurrentUser(options){
  return (dispatch) => {
    // Set Loading
    dispatch(fetchRequest())

    // Encode Params
    const promise = api('/admin/users/me.json', options)
      .then(response => response.json().then(json => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok){
          return Promise.reject(json)
        }
        dispatch(fetchSuccess(json))
      })
      .catch((json) => {
        dispatch(fetchFailure(json.errors))
      })

    return promise
  }
}

// Reducer
export default function reducer(state = initialState, action = {}){
  const { type, payload, errors } = action

  switch (type){
    case FETCH_REQUEST:
      return Object.assign({}, state, {
        loading: true,
      })
    case FETCH_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        loaded: true,
        result: payload,
      })
    case FETCH_FAILURE:
      return Object.assign({}, initialState, { errors })
    default:
      return state
  }
}
